/**
 * F-170 B3.3 — single source of truth for the "від {price} €" prefix.
 *
 * Backend exposes `price_is_from` (`ServicePreset`, `ProductOffering`,
 * `Order`). All UI surfaces that render a price (`ServiceCard`,
 * `PresetCard`, `OrderCard`, `ProductCard`) must call this helper so
 * the "from" wording stays consistent and a single tweak (e.g. switch
 * EUR → "EUR" or to "starting at") flows everywhere.
 *
 * The numeric is coerced through `Number()` because the backend hands
 * back a Decimal as either a JS number or a string depending on the
 * serializer; rounding to 2dp matches the original `toFixed(2)` calls
 * we're replacing.
 */
export function formatPrice(price: number | string, isFrom?: boolean): string {
  const n = Number(price);
  const fixed = Number.isFinite(n) ? n.toFixed(2) : String(price);
  return isFrom ? `від ${fixed} €` : `${fixed} €`;
}
